import React from 'react';

export default function NotFoundPage() {
  return (
    <div className="p-6">
      <h2 className="text-xl font-semibold text-slate-900">Not Found</h2>
      <p className="mt-2 text-sm text-slate-600">The page you requested does not exist.</p>
    </div>
  );
}
